import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import { colors } from 'design-system';
import { Check } from 'react-feather';

const useStyle = makeStyles(() => ({
  infoText: {
    fontSize: 15,
    fontWeight: 500,
    textTransform: 'capitalize',
  },
  moneyText: {
    fontSize: 17,
    fontWeight: 400,
    color: '#4A4B4E',
  },
}));

type Props = {
  name: string;
  value: string;
  iconCheck?: boolean;
};

const BenefitRow = ({ name, value, iconCheck }: Props): JSX.Element => {
  const classes = useStyle();
  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Box sx={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
        {iconCheck && (
          <Box
            sx={{
              borderRadius: '50%',
              width: 25,
              height: 25,
              bgcolor: colors.madison,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 10,
            }}
          >
            <Check data-testid="check-icon" color="white" size={20} />
          </Box>
        )}
        <Typography data-testid="benefit-name" className={classes.infoText}>
          {name}
        </Typography>
      </Box>
      <Box sx={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
        <Typography data-testid="benefit-value" className={classes.moneyText}>
          {value}
        </Typography>
      </Box>
    </Grid>
  );
};

export default BenefitRow;
